<template>
    <Row style="height: 98%; margin-top: 4%;" type="flex" justify="center">
        <!--外呼-->
        <template v-if="who === 'out'">
            <Col class='elev-display-btn-box' :class="{within16: list.length < 16}" v-for="n in 4" v-if="list.length>(16*(n-1))" :key="n">
                <template v-for="(floor,index) of list.slice(16*(n-1), 16*n)">
                    <li  :key="index" class='elev-display-btn' :out="floor.out" :class="{active:floor.out}"><span>{{floor.display}}</span></li>
                </template>
            </Col>
        </template>
        <!--内选-->
        <template v-else-if="who==='in'">
            <Col class='elev-display-btn-box' :class="{within16: list.length < 16}" v-for="n in 4" v-if="list.length>(16*(n-1))" :key="n">
                <li v-for="(floor,index) of list.slice(16*(n-1), 16*n)" :key="index" class='elev-display-btn' :in="floor.in" :class="{active:floor.in}"><span>{{floor.display}}</span></li>
            </Col>
        </template>
    </Row>
</template>

<script>
    export default {
        name: 'display-btns',
        props: {
            list: Array,
            who: String,
            showBtn:{
                type:Boolean,
                default:false
            }
        },
        data () {
            return {

            }
        },
        methods:{

        }
    };
</script>

<style scoped>
    ul,li{
        list-style: none;
    }
    .elev-display-btn-box{
        position: relative;
        width: 25%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        float: right;
        flex-direction: column-reverse;
        justify-content: flex-start;
        user-select: none;
        margin: 0 auto;
    }
    .elev-display-btn-box.within16 {
        justify-content: center ;
    }
    .elev-display-btn-box>li {
        width: 20px;
        height: 6.25%;
        min-height: 20px;
    }
    .elev-display-btn-box>li>span{
        display: inline-block;
        width: 20px;
        height: 20px;
        cursor: default;
        margin-right: auto;
        margin-left: auto;
        font-size: 8px;
        background: linear-gradient(135deg, #ddd 40%, #aaa 60%,#ddd 10%); /* 标准的语法 */
        box-shadow: 1px 1.5px 3px #888;
        text-align: center;
        line-height: 19px;
        font-weight: bold;
        border-radius: 50%;
        border: 2px solid #fcfcfc;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }
    .elev-display-btn-box>li.active[out='1']>span::before,
    .elev-display-btn-box>li.active[out='3']>span::before{
        content:' ';
        background-image: url(/images/device/up.png);
        background-size: auto 100%;
        display: block;
        height: 6px;
        width: 6px;
        position: absolute;
        top: -1px;
        left: 50%;
        margin-left: -3px;
        text-align: center;
        font-weight: 900;
        color: #f00;
    }
    .elev-display-btn-box>li.active[out='2']>span::after,
    .elev-display-btn-box>li.active[out='3']>span::after{
        content:' ';
        display: block;
        background-image: url(/images/device/down.png);
        background-size: auto 100%;
        height: 6px;
        width: 6px;
        position: absolute;
        bottom: -1.5px;
        left: 50%;
        margin-left: -3px;
        text-align: center;
        font-weight: 900;
        color: #f00;
    }
    .elev-display-btn-box>li.active {
        background: transparent;
    }
    .elev-display-btn-box>li.active>span{
        background: linear-gradient(135deg, #ff0 40%, #ddd 60%,#ff0 10%); /* 标准的语法 */
    }
</style>